import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom"; // დავამატეთ useNavigate
import { useTranslation } from "react-i18next";
import { getMyQrsAction } from "../actions/orderActions";
import {
  getCurrentUserData,
  logoutAction,
  changeSignupModalDisplay,
  changeLoginModalDisplayAciton,
} from "../actions/authActions";
import { getToken } from "../utils";
import Login from "../pages/auth/Login";
import Image from "./Image";
import Signup from "../pages/auth/Signup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHouse,
  faStore,
  faBookOpen,
  faPaw,
  faArrowLeft,
  faUser,
  faShieldDog,
  faShieldCat,
  faLocationDot, // დავამატეთ უკან დაბრუნების აიქონი
} from "@fortawesome/free-solid-svg-icons";

// დაამატე საჭირო Props: isLogedIn, userData, changeLoginModalDisplayAciton, darkMode
const MobileBottomNav = ({
  userData,
  changeLoginModalDisplayAciton,
  loginModalDisplay,
  myQRS,
  getMyQrsAction,
  darkMode,
}) => {
  const lastScrollY = useRef(0);
  const [hidden, setHidden] = useState(false);
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const [isLogedIn, setIsLogedIn] = useState(null);

  // ამ State-ს გამოვიყენებთ მხოლოდ კომპონენტის დასააფდეითებლად
  const [updateTick, setUpdateTick] = useState(0);

  const isHomePage = location.pathname === "/";

  const isActive = (path) => {
    if (path === "/") return location.pathname === "/";
    return (
      location.pathname === path || location.pathname.startsWith(path + "/")
    );
  };

  // ახალი ლოკაციის შემოწმების ლოგიკა
  const hasUnseenLocation = () => {
    if (!myQRS || myQRS.length === 0) return false;
    return myQRS.some((qr) => {
      if (!qr.last_location_time) return false;
      const lastSeen = localStorage.getItem(`seen_loc_${qr.uuid}`);
      return !lastSeen || lastSeen !== qr.last_location_time;
    });
  };

  const showBadge = hasUnseenLocation();

  useEffect(() => {
    const token = getToken();
    if (token !== null && userData === null) {
      getCurrentUserData();
      setIsLogedIn(true);
      changeLoginModalDisplayAciton("none");
    } else if (token !== null && userData !== null) {
      setIsLogedIn(true);
      changeLoginModalDisplayAciton("none");
    } else {
      setIsLogedIn(false);
    }
  }, [userData]);

  // პოლინგის ეფექტი
  useEffect(() => {
    const token = getToken();
    if (token && userData) {
      // პირველი ჩატვირთვა
      getMyQrsAction();

      // ინტერვალი 30 წამში ერთხელ
      const interval = setInterval(() => {
        // მხოლოდ მაშინ განაახლოს, თუ იუზერს საიტი ღია აქვს და უყურებს
        if (document.visibilityState === "visible") {
          getMyQrsAction();
        }
      }, 30000);

      return () => clearInterval(interval);
    }
  }, [userData, getMyQrsAction]);

  useEffect(() => {
    const handleStorageChange = () => {
      // როდესაც localStorage შეიცვლება, ეს "თიკი" შეიცვლება და წერტილის ლოგიკა თავიდან გაეშვება
      setUpdateTick((prev) => prev + 1);
    };

    // ვუსმენთ 'storage' ივენთს (სხვა ტაბებისთვის) და 'location-seen' ივენთს (ამავე ტაბისთვის)
    window.addEventListener("storage", handleStorageChange);
    window.addEventListener("location-seen", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("location-seen", handleStorageChange);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY.current && currentScrollY > 50) {
        setHidden(true);
      } else {
        setHidden(false);
      }
      lastScrollY.current = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // "მეტი" ამოვიღეთ აქედან, რადგან მისი ლოგიკა განსხვავებულია
  const navItems = [
    { path: "/", icon: faHouse, label: t("home") },
    { path: "/qrcollar", icon: faBookOpen, label: t("instruction") },
    { path: "/order/qrcollar", icon: faStore, label: t("buy") },
    { path: "/generateqr", icon: faLocationDot, label: t("my tags") },
  ];

  return (
    <>
      <Login
        loginModalDisplay={loginModalDisplay}
        setLoginModalDisplay={changeLoginModalDisplayAciton}
      />
      <Signup />
      <nav className={`mobile-nav ${hidden ? "hidden" : ""}`}>
        <div className="nav-inner">
          {/* ძირითადი 4 აიქონი */}
          {navItems.map((item) => {
            const active = isActive(item.path);
            const isMyTags = item.path === "/generateqr";

            return (
              <Link
                key={item.path}
                to={item.path}
                className={`nav-item ${active ? "active" : ""}`}
              >
                <div className="nav-content" style={{ position: "relative" }}>
                  <FontAwesomeIcon
                    icon={item.icon}
                    style={{ color: active ? "#ff6500" : "#9CA3AF" }}
                  />

                  {isMyTags && showBadge && (
                    <span className="notification-dot"></span>
                  )}

                  <span style={{ color: active ? "#ff6500" : "#404040" }}>
                    {item.label}
                  </span>
                </div>
              </Link>
            );
          })}

          {/* მე-5 ელემენტი: პროფილის ლოგიკა */}
          <div className="nav-item">
            {isLogedIn ? (
              <Link to="/userpanelpage" className="nav-content">
                <Image
                  src={userData?.profile_pic}
                  imgClassName="user-photo-in-nav-menu"
                  alt="profile"
                />
                <span>{t("profile")}</span>
              </Link>
            ) : (
              <div
                className="nav-content"
                onClick={() => changeLoginModalDisplayAciton("block")}
                style={{ cursor: "pointer" }}
              >
                <FontAwesomeIcon
                  icon={faUser}
                  style={{ color: "#9CA3AF", width: "1.1rem" }}
                />
                <span>{t("login")}</span>
              </div>
            )}
          </div>
        </div>
      </nav>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData.userData,
    myQRS: state.orders.myQRS,
    loginModalDisplay: state.userData.loginModalDisplay,
  };
};

export default connect(mapStateToProps, {
  getCurrentUserData,
  logoutAction,
  changeSignupModalDisplay,
  changeLoginModalDisplayAciton,
  getMyQrsAction,
})(MobileBottomNav);
